import { motion } from 'framer-motion';
import { Building2 } from 'lucide-react';

const clientsByIndustry = {
  'Infrastructure & Power': [
    'Genus Power & Infrastructures Ltd',
    'Genus Electrotech Ltd',
    'Ratnawali Infrastructures Pvt Ltd',
    'Janak Nandini Infrastructures Pvt Ltd',
    'Oswal Cables Private Limited'
  ],
  'Real Estate & Construction': [
    'Akshat Apartments Private Limited',
    'Okay Plus Group',
    'Sukhi Jeevan Buildcon LLP',
    'SNG Group: Builders And Developers',
    'Kogta Housing Development',
    'Zuberi Engineering Construction Pvt Ltd'
  ],
  'Manufacturing': [
    'Shri Krishna Rolling Mills Limited',
    'Agarwal Toughened Glass India Pvt Ltd',
    'Saraf Lumbers Private Limited',
    'Baid Rotomoulders Private Limited',
    'Nirmal Glasstech Industries',
    'Perfect Alex Private Limited',
    'Manas Industries',
    'Minova Runaya Private Limited'
  ],
  'Healthcare & Medical': [
    'Poly Medicure Limited',
    'Soni Medicare Ltd',
    'Amar Medical And Research Centre'
  ],
  'Hospitality & Tourism': [
    'Chokhi Dhani Resorts Private Limited',
    'Holiday Inn Express Jaipur'
  ],
  'Textile & Fashion': [
    'Nash Fashion India Ltd',
    'Swaraj Suitings Pvt Ltd',
    'Kamakshi Craftex Pvt Ltd',
    'Ginni Non Wovens',
    'Race Thread',
    'HS Fashion'
  ],
  'Food & Agro': [
    'Shri Adinath Cashew Pvt Ltd',
    'Bombay Misthan Bhandar'
  ],
  'Trading & Export': [
    'Goodwill Impex Limited',
    'Pawan Enterprises',
    'RKM International LLP'
  ],
  'Jewellery': [
    'Millennium Jewellery Private Limited',
    'Rambhajo Jewellers',
    'Gouriwala'
  ],
  'Technology & Others': [
    'Stellar Blue Technologies',
    'Mirelle Designs LLP',
    'Shyam Knowledge Park Shiksha Samiti'
  ]
};

export const ClientsList = () => (
  <section className="py-24 bg-white" data-testid="client-list-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <span className="inline-block px-4 py-2 bg-[#f1f5f9] rounded-full text-sm font-medium text-[#3b5998] mb-4">
          Our Clients
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Trusted Across Industries
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          Businesses across diverse sectors trust us for their financial consultancy needs.
        </p>
      </motion.div>

      <div className="space-y-16">
        {Object.entries(clientsByIndustry).map(([industry, clients], industryIndex) => (
          <motion.div
            key={industry}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: industryIndex * 0.1 }}
            className="bg-[#f8fafc] rounded-2xl p-8"
          >
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white shadow-lg">
                <Building2 className="w-6 h-6" />
              </div>
              <div>
                <h3 className="font-heading text-xl font-semibold text-[#0f172a]">
                  {industry}
                </h3>
                <span className="text-sm text-[#64748b]">
                  {clients.length} trusted clients
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {clients.map((client, clientIndex) => (
                <motion.div
                  key={client}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: clientIndex * 0.03 }}
                  className="px-5 py-4 bg-white rounded-xl border border-slate-200 hover:border-[#00bcd4]/50 hover:shadow-md transition-all"
                >
                  <p className="font-medium text-[#0f172a] text-sm" title={client}>
                    {client}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
